import { backend } from 'services';
import type { CountriesByName } from 'types';

import { apiPaths } from './routes';

export function getCountries(): Promise<CountriesByName> {
  return backend.get(`${apiPaths.setupData}/country`);
}
